import React from "react";
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  CircularProgress,
  Box,
} from "@mui/material";

const FiltersPanel = ({
  locations,
  rooms,
  lines,
  filters,
  setFilters,
  loading,
  onLoad,
  onDownload,
  onPublish,
  publishing = false,
  userRole,
  userLocation,
}) => {
  const handleChange = (field) => (event) => {
    setFilters({ ...filters, [field]: event.target.value });
  };

  const canPublish =
    (userRole === "Administrator" ||
      userRole === "Admin" ||
      userRole === "Site Admin") &&
    (userLocation === filters.location || userRole === "Administrator");

  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        borderRadius: 2,
        p: 2,
        boxShadow: "0 2px 4px rgba(0,0,0,0.08)",
        mb: 1,
      }}
    >
      <Grid container spacing={2} alignItems="center">
        {/* Location */}
        <Grid item xs={12} sm={3} md={2.5}>
          <FormControl fullWidth disabled={loading}>
            <InputLabel id="location-label">Location</InputLabel>
            <Select
              labelId="location-label"
              value={filters.location || ""}
              label="Location"
              onChange={handleChange("location")}
            >
              {locations.map((loc) => (
                <MenuItem key={loc} value={loc}>
                  {loc}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        {/* Room */}
        <Grid item xs={12} sm={3} md={2.5}>
          <FormControl fullWidth disabled={!filters.location || loading}>
            <InputLabel id="room-label">Room</InputLabel>
            <Select
              labelId="room-label"
              value={filters.roomId || ""}
              label="Room"
              onChange={handleChange("roomId")}
            >
              <MenuItem value="">None</MenuItem>
              {rooms.map((room) => (
                <MenuItem key={room} value={room}>
                  {room}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        {/* Line */}
        <Grid item xs={12} sm={3} md={2.5}>
          <FormControl fullWidth disabled={!filters.location || loading}>
            <InputLabel id="line-label">Line</InputLabel>
            <Select
              labelId="line-label"
              value={filters.lineId || ""}
              label="Line"
              onChange={handleChange("lineId")}
            >
              <MenuItem value="">None</MenuItem>
              {lines.map((line) => (
                <MenuItem key={line} value={line}>
                  {line}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        {/* Start Date */}
        <Grid item xs={12} sm={3} md={2.25}>
          <FormControl fullWidth>
            <InputLabel shrink htmlFor="start-date-input">
              Start Date
            </InputLabel>
            <input
              id="start-date-input"
              type="date"
              value={filters.startDate || ""}
              onChange={handleChange("startDate")}
              style={{
                width: "100%",
                padding: "14px",
                fontSize: "15px",
                border: "1px solid #ccc",
                borderRadius: "6px",
                marginTop: "8px",
              }}
            />
          </FormControl>
        </Grid>

        {/* End Date */}
        <Grid item xs={12} sm={3} md={2.25}>
          <FormControl fullWidth>
            <InputLabel shrink htmlFor="end-date-input">
              End Date
            </InputLabel>
            <input
              id="end-date-input"
              type="date"
              value={filters.endDate || ""}
              onChange={handleChange("endDate")}
              style={{
                width: "100%",
                padding: "14px",
                fontSize: "15px",
                border: "1px solid #ccc",
                borderRadius: "6px",
                marginTop: "8px",
              }}
            />
          </FormControl>
        </Grid>

        {/* Actions Row */}
        <Grid item xs={12} sm={12} md={12}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 1.5,
              flexWrap: "wrap",
              mt: 1,
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={onLoad}
              disabled={loading}
              sx={{ minWidth: 140, textTransform: "none", fontWeight: 600 }}
            >
              {loading ? <CircularProgress size={22} color="inherit" /> : "Load Schedule"}
            </Button>

            <Button
              variant="contained"
              color="info"
              onClick={onDownload}
              sx={{ minWidth: 140, textTransform: "none", fontWeight: 600 }}
            >
              Download PDF
            </Button>

            {onPublish && (
              <Button
                variant="contained"
                color="secondary"
                onClick={onPublish}
                disabled={!canPublish || publishing || loading}
                sx={{
                  minWidth: 140,
                  textTransform: "none",
                  fontWeight: 600,
                  backgroundColor: canPublish
                    ? "#6a1b9a"
                    : "#bdbdbd",
                  "&:hover": {
                    backgroundColor: canPublish
                      ? "#4a148c"
                      : "#bdbdbd",
                  },
                }}
              >
                {publishing ? <CircularProgress size={22} color="inherit" /> : "Publish"}
              </Button>
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default FiltersPanel;
